<template>
  <div id="app">
<!--     <header class="header">
      <nav class="inner">
        <router-link to="/" exact>What</router-link>
        <router-link to="/is">Is</router-link>
        <router-link to="/this">This</router-link>
        <router-link to="/menu">Menu</router-link>
        <router-link to="/for">For</router-link>
      </nav>
    </header> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// App.vue?380ba050